import {Component, OnInit} from '@angular/core';
import {Question} from "../question/question";
import {Trabalho} from "../trabalho/trabalho";
import {QuestionService} from "../question/question.service";
import {TrabalhoService} from "../trabalho/trabalho.service";
import {ActivatedRoute, Router} from "@angular/router";
import {_if} from "rxjs/observable/if";
import {AppComponent} from "../app.component";

@Component({
    selector: 'app-avaliacao-detail',
    templateUrl: './avaliacao-detail.component.html',
    styleUrls: ['./avaliacao-detail.component.css'],
    providers: [
        QuestionService
    ]
})

export class AvaliacaoDetailComponent extends AppComponent implements OnInit {
    questions: Question[];
    trab_id: number;
	ver: boolean;
	trabalho: any;

    ngOnInit() {
		if (!this.isAdmin() && !this.isParecerista()) 
			this.router.navigateByUrl('acesso');
		else
		{
			this.route.params.subscribe(params => this.trab_id = parseInt(params['id_t']));
			this.route.params.subscribe(params => this.ver = (params['ver'] == 'ver'));	
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/avaliacao-detail/avaliacao-detail.component.ts